import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import {setLookActiveFeature, updateNavigationCount} from "../../../../../actions/lookFunctions";
import {getFeatureOptions, getOptionStyles, navFeatureCLick} from "../../lookFunctions";
import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import {allowCheckForCollection} from "../../../grohe/groheNavigation/groheFunctions";
import Config, {IS_PRODUCT_JOURNEY} from "../../../../../config";

import WithClickCount from "../../../hocs/withClickCount";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {enableRelatedFeature, getDbFeatureProperty} from "../../lookFunctions2";
import PropTypes from "prop-types";
import {setWizardSelectedValues} from "../../../../../actions/wizardFunctions";
import {wizardGroupInterface} from "../../../../../interfaces/wizardItemInterface";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import {getColorFilterValue} from "../../../../../misc/filtersFunctions";
import {changeToClickFeatureAccordingCurrentPosition} from "../../lookFunctions3";

const LookFeatureOptions = (props) => {

  const {lookActiveFeature, filterGroups, setLookActiveFeature, lookActiveFeatureCustomName, updateCanvasCount,
    lookActiveFeatureCollection, lookActiveFeatureMatchingFeature, lookActiveFeatureMountType, lookActiveFeatureMountHoles,
    lookActiveFeatureLixilSubCategory, isWizard, wizardActiveStep, wizardGroup, setWizardSelectedValues, fabricatorData,
    updateNavigationCount, featureGroupCount, lookActiveFeaturePositionInList} = props;
  const [availableOptions, setAvailableOptions] = useState([]);

  const checkCollectionName = lookActiveFeature && !allowCheckForCollection(lookActiveFeature) ? "" : lookActiveFeatureCollection;

  useEffect(() => {
    if (fabricatorData.isEncore) {
      return
    }
    const colorOptions = getFeatureOptions(lookActiveFeature, filterGroups, "Color");
    setAvailableOptions(colorOptions || [])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeatureCustomName, checkCollectionName, lookActiveFeatureMatchingFeature,
    lookActiveFeatureMountType, lookActiveFeatureLixilSubCategory, lookActiveFeatureMountHoles, featureGroupCount]);

  if (!availableOptions.length || fabricatorData.isEncore) {
    return null
  }

  const activeFilterGroupValue = getColorFilterValue(lookActiveFeature, filterGroups)

  const optionsButtonClick = (option, maxClickCountReached, updateLookCartItem) => {

    const featureLabel = Analytics.getSkuForAnalytics(lookActiveFeature);
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureOptions + featureLabel
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureOptions + featureLabel;
    Analytics.sendClickEvent(analyticsLabel);

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    if (Config.isDevMode()) {
      console.log("option.feature", option.feature);
    }

    let toClickOptionFeature = changeToClickFeatureAccordingCurrentPosition(option.feature);

    if (isWizard) {
      setWizardSelectedValues({
        [wizardActiveStep]: {
          wizardGroup,
          selectedFeature: toClickOptionFeature,
          partId: toClickOptionFeature.partId
        }
      });
    }

    setLookActiveFeature(option.feature, lookActiveFeaturePositionInList);
    navFeatureCLick(toClickOptionFeature);
    enableRelatedFeature(toClickOptionFeature);
    updateLookCartItem(toClickOptionFeature);
    updateNavigationCount();
    updateCanvasCount();
  };

  return (
    <div className="lk-feature__options">
      <span className="lk-feature__options-title">
        <FormattedMessage id="grohe.filter.color"/>:
        {/*{IS_PRODUCT_JOURNEY ? ":" : null}*/}
        {/*{activeFilterGroupValue && (IS_PRODUCT_JOURNEY) ? (*/}
          <span className="lk-feature__options-title-text">
            {activeFilterGroupValue ? (activeFilterGroupValue.displayText || activeFilterGroupValue.value).replace("GROHE ", "") : null}
          </span>
        {/*) : null}*/}
      </span>
      {/*{activeFilterGroupValue && !IS_PRODUCT_JOURNEY ? (*/}
      {/*  <span className="lk-feature__options-sub-title">*/}
      {/*    ({activeFilterGroupValue.displayText.replace("GROHE ", "")})*/}
      {/*  </span>*/}
      {/*) : null}*/}
      <WithClickCount>
        {(maxClickCountReached) => (
          <WithUpdateLookCartItem>
            {(updateLookCartItem) => (
              <ul className="lk-feature__options-list">
                {availableOptions.map(option => {
                  const isActive = activeFilterGroupValue && (option.colorValue.id === activeFilterGroupValue.id);
                  const styles = getOptionStyles(option.colorValue);
                  return (
                    <li className={"lk-color lk-color--" + option.colorValue.id +  (isActive ? " lk-color--active" : "")}
                        key={option.colorValue.id}
                        onClick={() => optionsButtonClick(option, maxClickCountReached, updateLookCartItem)}
                        style={styles}/>
                  )
                })}
              </ul>
            )}
          </WithUpdateLookCartItem>
        )}
      </WithClickCount>
    </div>

  )
};

LookFeatureOptions.propTypes = {
  isWizard: PropTypes.bool,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {featureGroupCount, lookActiveFeaturePositionInList} = store.lookState;
  const storeActiveFeature = store.lookState.lookActiveFeature;
  const {filterGroups} = store.filterState;
  const {wizardActiveStep} = store.wizardState;
  const lookActiveFeature = ownProps.activeFeature || storeActiveFeature;
  const fabricatorData = store.fabricatorState;

  return {
    lookActiveFeature,
    lookActiveFeaturePositionInList,
    filterGroups,
    wizardActiveStep,
    lookActiveFeatureCustomName: lookActiveFeature ? lookActiveFeature.getMatchingOptionsName() : null,
    lookActiveFeatureMountHoles: lookActiveFeature && lookActiveFeature.partId === "vanity_sink"
    && Array.isArray(lookActiveFeature.dbFeature.metaData["MountHoles"])
      ? lookActiveFeature.dbFeature.metaData["MountHoles"].join(",") : null,
    lookActiveFeatureLixilSubCategory: lookActiveFeature ? lookActiveFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] : null,
    lookActiveFeatureMatchingFeature: lookActiveFeature && Array.isArray(lookActiveFeature.dbFeature.metaData["MatchingFeature"])
      ? lookActiveFeature.dbFeature.metaData["MatchingFeature"].join(",")
      : null,
    lookActiveFeatureMountType: lookActiveFeature && Array.isArray(lookActiveFeature.dbFeature.metaData["MountType"])
      ? lookActiveFeature.dbFeature.metaData["MountType"].join(",")
      : null,
    lookActiveFeatureCollection: lookActiveFeature ? lookActiveFeature.getCollectionName(filterGroups) : null,
    featureGroupCount, // to update options after all features received
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookActiveFeature,
  updateCanvasCount,
  setWizardSelectedValues,
  updateNavigationCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookFeatureOptions)
